<h2 mat-dialog-title class="text-lg font-bold mb-1">
  Horario(s) de Entrega
</h2>
<mat-dialog-content class="modal-content">
  <form [formGroup]="formData" class="grid grid-cols-1 gap-4">
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Hora de Inicio</mat-label>
      <mat-icon matSuffix>schedule</mat-icon>
      <input
        matInput
        formControlName="hourStart"
        name="hourStart"
        placeholder="Inicio"
        readonly required
        [ngxTimepicker]="default1"
      />
      <ngx-material-timepicker #default1></ngx-material-timepicker>
    </mat-form-field>

    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Hora de Fin</mat-label>
      <mat-icon matSuffix>schedule</mat-icon>
      <input
        matInput
        formControlName="hourEnd"
        name="hourEnd"
        placeholder="Fin"
        readonly required
        [ngxTimepicker]="default2"
      />
      <ngx-material-timepicker #default2></ngx-material-timepicker>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-end">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!formData.valid"
    class="justify-end"
  >
    {{ "Guardar" }}
  </button>
</mat-dialog-actions>